import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { channelsApi } from "../http/Api";

export const getChannels = createAsyncThunk('Channels/getChannels', async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await channelsApi.getChannels(serverId);
    console.log('response',response);

    if(response.status === 200) {
        thunkAPI.dispatch(channelsSlice.actions.setChannels(response))
    }
})

const initialState = {
    channelsGlobalState: null,
}

const channelsSlice = createSlice({
    name: 'channels',
    initialState,
    reducers: {
        setChannels: (state, action) => {
            state.channelsGlobalState = action.payload
        }
    }
})

export const channels = channelsSlice.reducer;
